import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';

const Settings = () => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
  const env = process.env.NODE_ENV || 'development';

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Configurações
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Informações da Aplicação
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="textSecondary">API URL</Typography>
            <Typography variant="body1">{apiUrl}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="textSecondary">Ambiente</Typography>
            <Typography variant="body1">{env}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Settings;